export default "__VITE_ASSET__DPOVR$Gb__"